<template>
  <div class="mb-8">
    <h2>
      {{ title }}
    </h2>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>
<style scoped lang="scss">
div {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  img {
    width: 20px;
    margin-left: 10px;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
